import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <GoogleOAuthProvider clientId="813304549531-ka9q4h3mu2sof9ato8fkocdpu4dds5j4.apps.googleusercontent.com">
    <BrowserRouter>
    <HelmetProvider>
        <App />
    </HelmetProvider>
    </BrowserRouter>
  </GoogleOAuthProvider>
  </>
);
